export default function StatCard({ label, value, sub, icon: Icon, accent, testId }) {
  return (
    <div
      className="bg-white border border-zinc-200 rounded-lg p-6 hover:shadow-sm transition-shadow"
      data-testid={testId}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500">
          {label}
        </div>
        {Icon && (
          <div
            className={`w-8 h-8 rounded-md flex items-center justify-center ${
              accent || "bg-zinc-100 text-zinc-700"
            }`}
          >
            <Icon className="w-4 h-4" strokeWidth={1.75} />
          </div>
        )}
      </div>
      <div className="font-display text-3xl font-semibold text-zinc-900 tabular-nums">
        {value}
      </div>
      {sub && <div className="text-xs text-zinc-500 mt-1">{sub}</div>}
    </div>
  );
}
